export const HOMEPAGE_ROUTE_URL = '/';
export const OMGEVING_ROUTE_URL = '/omegeving-daumazan';
export const CHATEAU_ROUTE_URL = '/chateau-cazaleres';
export const VILLAS_ROUTE_URL = '/luxe-vakantie-villas';
export const CONTACT_ROUTE_URL = '/contact';
